import React from 'react';

function renderButtonTabsBlock(data, index) {
  return (
    <div style={{ backgroundColor: data.BACKGROUND_COLOR }} className={'delimiter_wrapper'} key={index}>
      <div className={'container'}>
        <hr />
      </div>
    </div>
  );
}

export default renderButtonTabsBlock;